import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './FieldMessage.scss';

interface IOwnProps {
  error?: boolean;
  warning?: boolean;
  info?: boolean;
  message: {};
}

const FieldMessage: React.SFC<IOwnProps> = ({ message, error, warning, info }) => {
  const fieldMessageClassNames = cx({
    [Styles.message]: true,
    [Styles.error]: error,
    // [Styles.warning]: warning,
    // [Styles.info]: info,
  });

  return <span className={fieldMessageClassNames}>{message}</span>;
};

export default FieldMessage;
